/* Skindion (misión 07k): pantalla de carga al pasar al checkout y API window.SkindionLoader.
   Diseño: «Cinta» (propuesta C de Mau, 2026-10-29) con la promo de la página o, si la clienta llegó por una promo y
   paga desde otra página, la de su sesión (SkindionLoaderConfig.promoSesion); «Pulso» (propuesta A de Mau,
   2026-10-11, México) fuera de las promos. La entrada la pone el inline de snippets/skindion-loader.liquid, que
   también arma las cintas (SkindionLoaderConfig.cintas); el look vive en assets/skindion-loader.css.

   API:  SkindionLoader.show(motivo, origen?)   'checkout' = «Abriendo tu pago seguro», tope de 8 s
                                                 otro motivo = «Cargando», tope de 2.5 s
                                                 origen: elemento del que nace el rosa (opcional)
         SkindionLoader.hide()                   quita la de checkout y la de entrada

   ── Principio rector: NUNCA frenar una venta ─────────────────────────────────────────────────────────────────────
   No navega, no retrasa y no frena el primer envío: solo mira. Si algo falla (CSS sin cargar, navegador viejo), lo
   peor es que no haya pantalla. La barra no espera a llenarse: el checkout abre en cuanto Shopify responde.

   ── Cuándo sale al checkout (ajuste «Al pasar al checkout») ──────────────────────────────────────────────────────
   1. Envío de un formulario al checkout: botón con name="checkout" (los dos de Horizon, también el del carrito de la
      promo) o action a /checkout. El carrito de la promo sale del pop-up de Priority+ con
      form.requestSubmit(button), que también dispara submit: no hace falta tocar sus archivos.
   2. Clic en un enlace a /checkout o /checkouts.
   3. Navegación por JS (location.assign): no se puede ver desde fuera. Quien la haga llama antes a
      SkindionLoader.show('checkout') (docs/loader.md, la línea para el carrito).
   Se decide un tick DESPUÉS del evento: si alguien lo frenó (defaultPrevented), no sale. El pop-up de Priority+ frena
   el clic del botón, así que no hay envío ni pantalla mientras el pop-up está abierto: la pantalla nunca va encima.
   Shop Pay, PayPal y los botones acelerados no envían el formulario ni son enlaces: se quedan sin pantalla.

   ── Salidas de emergencia ────────────────────────────────────────────────────────────────────────────────────────
   - Tope de 8 s en checkout: si no se navegó (red caída), se quita y el botón vuelve a funcionar.
   - Doble clic: mientras está visible y ya pasó un envío, los siguientes envíos y clics al checkout se frenan.
   - pageshow con persisted (vuelta con «atrás» desde el bfcache): se quita todo. */
(function () {
  'use strict';

  var w = window;
  var d = document;
  if (w.SkindionLoader && w.SkindionLoader.version) return;

  var config = w.SkindionLoaderConfig || { entrada: false, checkout: false };
  var previo = w.SkindionLoader;
  var TOPE_CHECKOUT_MS = 8000;
  var TOPE_MS = 2500;
  var SALIDA_MS = 250;
  var A_CHECKOUT = /^(\/[a-z]{2}(-[a-z]{2})?)?\/checkouts?(\/|$)/i;
  var CANDADO =
    '<svg viewBox="0 0 13 14" aria-hidden="true" focusable="false">' +
    '<rect x="1.25" y="6" width="10.5" height="7.25" rx="1.75"/>' +
    '<path d="M3.6 6V4.1a2.9 2.9 0 0 1 5.8 0V6"/></svg>';

  var el = null;
  var hechos = {}; /* una pantalla por diseño: pulso, cinta-50, cinta-2x1 */
  var motivo = null;
  var paso = false; /* ya salió un envío o clic al checkout con la pantalla puesta */
  var tTope = 0;
  var tSalida = 0;
  var conPopover = typeof HTMLElement !== 'undefined' && Object.prototype.hasOwnProperty.call(HTMLElement.prototype, 'popover');

  function construir(diseno, promo) {
    var n = d.createElement('div');
    n.className = 'skd-loader skd-loader--checkout' + (promo ? ' skd-loader--cinta' : '');
    n.setAttribute('role', 'status');
    n.setAttribute('aria-live', 'polite');
    n.setAttribute('aria-hidden', 'true');
    if (conPopover) n.setAttribute('popover', 'manual');
    n.innerHTML =
      (promo
        ? config.cintas(promo)
        : '<div class="skd-loader__centro" aria-hidden="true">' +
          '<span class="skd-loader__halo"></span><span class="skd-loader__onda"></span><span class="skd-loader__onda"></span>' +
          '</div>') +
      '<div class="skd-loader__logo"></div>' +
      '<span class="skd-loader__barra"><i></i></span>' +
      '<p class="skd-loader__estado">' + CANDADO + '<span></span></p>';
    var logo = d.getElementById('SkdLoaderLogo');
    if (logo && logo.content) n.querySelector('.skd-loader__logo').appendChild(logo.content.cloneNode(true));
    d.body.appendChild(n);
    hechos[diseno] = n;
    return n;
  }

  /** La promo de la página, o la de la sesión si la clienta llegó por una promo; si no, el Pulso. */
  function disenoActual() {
    var promo = config.promoSesion || config.promo || '';
    if (typeof config.cintas !== 'function' || !config.cintas(promo)) promo = '';
    return { clave: promo ? 'cinta-' + promo : 'pulso', promo: promo };
  }

  function quitarEntrada() {
    if (previo && typeof previo.entrada === 'function') previo.entrada();
  }

  function hide() {
    quitarEntrada();
    w.clearTimeout(tTope);
    if (!el || !motivo) return;
    var n = el;
    motivo = null;
    paso = false;
    d.documentElement.removeAttribute('data-skd-loading');
    n.classList.add('is-done', 'is-out');
    n.setAttribute('aria-hidden', 'true');
    w.clearTimeout(tSalida);
    tSalida = w.setTimeout(function () {
      n.classList.remove('is-on', 'is-done', 'is-out');
      n.querySelector('.skd-loader__estado span').textContent = '';
      if (conPopover && n.matches(':popover-open')) n.hidePopover();
    }, SALIDA_MS);
  }

  /** @param {string} [razon] @param {Element} [origen] */
  function show(razon, origen) {
    var esCheckout = razon === 'checkout';
    if (esCheckout && !config.checkout) return;
    if (!d.body) return;
    if (motivo) {
      /* Ya hay pantalla: si era una genérica y ahora va al checkout, pasa a ser la del checkout. */
      if (esCheckout && motivo !== 'checkout') {
        motivo = 'checkout';
        el.querySelector('.skd-loader__estado span').textContent = 'Abriendo tu pago seguro';
        el.querySelector('.skd-loader__estado').style.visibility = '';
        w.clearTimeout(tTope);
        tTope = w.setTimeout(hide, TOPE_CHECKOUT_MS);
      }
      return;
    }
    var diseno = disenoActual();
    el = hechos[diseno.clave] || construir(diseno.clave, diseno.promo);
    /* Sin la hoja de estilos el nodo sería un bloque suelto al final de la página: mejor nada. */
    if (w.getComputedStyle(el).position !== 'fixed') return;
    quitarEntrada();
    w.clearTimeout(tSalida);
    el.classList.remove('is-done', 'is-out');

    /* El rosa nace del centro del botón que se pulsó. */
    var r = origen && origen.getBoundingClientRect ? origen.getBoundingClientRect() : null;
    el.style.setProperty('--skd-ld-x', r && r.width > 0 ? Math.round(r.left + r.width / 2) + 'px' : '50%');
    el.style.setProperty('--skd-ld-y', r && r.width > 0 ? Math.round(r.top + r.height / 2) + 'px' : '90%');

    motivo = razon || 'carga';
    paso = false;
    if (conPopover) el.showPopover();
    void el.offsetWidth; /* reflow: las animaciones arrancan desde cero */
    el.classList.add('is-on');
    el.removeAttribute('aria-hidden');
    d.documentElement.setAttribute('data-skd-loading', motivo);
    /* El texto entra con la región ya visible: así un lector de pantalla lo anuncia, sin interrumpir. */
    el.querySelector('.skd-loader__estado span').textContent = esCheckout ? 'Abriendo tu pago seguro' : 'Cargando';
    el.querySelector('.skd-loader__estado').style.visibility = esCheckout ? '' : 'hidden';
    tTope = w.setTimeout(hide, esCheckout ? TOPE_CHECKOUT_MS : TOPE_MS);
  }

  function vaAlCheckout(form, boton) {
    if (boton && boton.name === 'checkout') return true;
    try {
      return A_CHECKOUT.test(new URL(form.action, w.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  function enlaceAlCheckout(a) {
    var target = a.getAttribute('target');
    if (target && target !== '_self') return false;
    if (a.hasAttribute('download') || a.origin !== w.location.origin) return false;
    return A_CHECKOUT.test(a.pathname);
  }

  /* Un tick después: si nadie frenó el evento, la navegación al checkout ya está en marcha. */
  function cuandoPase(e, origen) {
    if (motivo === 'checkout') {
      if (paso) {
        e.preventDefault(); /* doble clic con la pantalla puesta */
        return;
      }
      paso = true;
      return;
    }
    w.setTimeout(function () {
      if (e.defaultPrevented) return;
      try {
        show('checkout', origen);
        paso = true;
      } catch (err) {
        /* la pantalla es un adorno: jamás puede romper el envío */
      }
    }, 0);
  }

  w.SkindionLoader = { version: '07k-1', show: show, hide: hide };

  if (config.checkout) {
    w.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement) || !vaAlCheckout(form, e.submitter)) return;
        cuandoPase(e, e.submitter || form);
      },
      true
    );

    w.addEventListener(
      'click',
      function (e) {
        if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a || !enlaceAlCheckout(a)) return;
        cuandoPase(e, a);
      },
      true
    );
  }

  /* La barra se completa justo cuando la página se va (si el navegador alcanza a pintar ese fotograma). */
  w.addEventListener('pagehide', function () {
    if (el && motivo) el.classList.add('is-done');
  });

  w.addEventListener('pageshow', function (e) {
    if (e.persisted) hide();
  });
})();
